import { Suspense } from 'react';
import { PersonReportHistory, PersonReportMailings } from '@features';
import { Skeleton, Stack } from '@mantine/core';

export const PersonDetailsReportsPage: React.FC = () => {
  return (
    <Stack py="md" gap="md">
      <Suspense fallback={<Skeleton height={200} />}>
        <PersonReportMailings />
      </Suspense>
      <Suspense fallback={<Skeleton height={400} />}>
        <PersonReportHistory />
      </Suspense>
    </Stack>
  );
};
